/**
 * Custom hook for managing PDF rotation
 *
 * Extracted from PDFViewerModal.tsx
 */

import { useState, useCallback } from 'react';
import type { Rotation } from '../types/pdf-viewer.types';

export interface UsePDFRotationReturn {
  rotation: Rotation;
  rotateClockwise: () => void;
  rotateCounterClockwise: () => void;
  resetRotation: () => void;
}

/**
 * Manages PDF page rotation state
 */
export function usePDFRotation(): UsePDFRotationReturn {
  const [rotation, setRotation] = useState<Rotation>(0);

  const rotateClockwise = useCallback(() => {
    setRotation(prev => ((prev + 90) % 360) as Rotation);
  }, []);

  const rotateCounterClockwise = useCallback(() => {
    setRotation(prev => ((prev - 90 + 360) % 360) as Rotation);
  }, []);

  const resetRotation = useCallback(() => {
    setRotation(0);
  }, []);

  return {
    rotation,
    rotateClockwise,
    rotateCounterClockwise,
    resetRotation,
  };
}
